var matrixTableManager = ( function (){

    function init(){
        $(document).ready(function(){
            if(!$("section.matrix-table-component").length) return;

            $("section.matrix-table-component").each(function(){
                tableComponent = $(this);
                $(this).find(".matrix-table-wrapper-mobile li.nav-item").on("click", function(){
                    enableTab($(this), $(this).index());
                })
            })
        })
    }

    function enableTab(clickedLink, index)
    {        
        buttons = tableComponent.find(".matrix-table-wrapper-mobile button.nav-link");
        buttons.removeClass("active");
        buttons.attr('aria-selected', 'false')
        clickedLink.find("button.nav-link").addClass("active");
        clickedLink.find("button.nav-link").attr('aria-selected', 'true')
        
        matrixTabContent = tableComponent.find("#matrixTableContent");
        matrixTabContent.find(".tab-pane").removeClass("show active");
        matrixTabContent.find(".tab-pane").eq(index).addClass("show active");

        
    }

    return {
        init: init
    }
})(jQuery)